import Swiper from "swiper";
import { Keyboard } from "swiper/modules";

// De slider werkt vanaf tablet; op mobiel staan de projecten onder elkaar (Figma), dus daar blijft Swiper uit.
const desktop = window.matchMedia("(min-width: 768px)");
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

document.querySelectorAll(".swiper_projects-layout").forEach((layout) => {
	const slider = layout.querySelector(".projects-swiper");
	const wrapper = slider?.querySelector(".swiper-wrapper");
	if (!wrapper) return;

	const originals = [...wrapper.children];
	if (originals.length < 2) return;

	const dots = layout.querySelector(".pk-pagination");
	const bullets = originals.map((slide, i) => {
		const bullet = document.createElement("button");
		bullet.type = "button";
		bullet.className = "swiper-pagination-bullet";
		bullet.setAttribute("aria-label", slide.querySelector(".project-card-title")?.textContent.trim() ?? "");
		dots?.append(bullet);
		return bullet;
	});

	let swiper = null;

	// De slides links van de actieve schuiven weg, die rechts ook (zie style.scss); de dots volgen de echte projecten.
	const sync = (instance) => {
		const active = instance.activeIndex;

		instance.slides.forEach((slide, i) => {
			slide.style.setProperty("--shift", Math.sign(i - active));
			slide.querySelector(".project-media")?.toggleAttribute("inert", i !== active);
		});

		const current = Number(instance.slides[active]?.dataset.project);
		bullets.forEach((bullet, i) => {
			bullet.classList.toggle("swiper-pagination-bullet-active", i === current);
			bullet.toggleAttribute("aria-current", i === current);
		});
	};

	const mount = () => {
		// Swiper zet de loop uit bij te weinig slides voor de breedte; daarom staan de projecten zo vaak in de lijst dat er minimaal 9 zijn.
		for (let round = 1; round < Math.ceil(9 / originals.length); round++) {
			originals.forEach((slide) => {
				const clone = slide.cloneNode(true);
				clone.dataset.clone = "";
				clone.setAttribute("aria-hidden", "true");
				wrapper.append(clone);
			});
		}

		swiper = new Swiper(slider, {
			modules: [Keyboard],
			centeredSlides: true,
			slidesPerView: "auto",
			loop: true,
			grabCursor: true,
			longSwipesRatio: 0.15,
			longSwipesMs: 250,
			threshold: 3,
			loopPreventsSliding: false,
			speed: reduceMotion.matches ? 0 : 450,
			keyboard: { enabled: true, onlyInViewport: true },
			on: { init: sync, slideChange: sync, transitionEnd: sync },
		});
	};

	const unmount = () => {
		swiper?.destroy(true, true);
		swiper = null;
		wrapper.querySelectorAll("[data-clone]").forEach((clone) => clone.remove());
		wrapper.querySelectorAll(".swiper-slide").forEach((slide) => {
			slide.style.removeProperty("--shift");
			slide.querySelector(".project-media")?.removeAttribute("inert");
		});
	};

	bullets.forEach((bullet, i) => {
		bullet.addEventListener("click", () => {
			const nearest = swiper?.slides
				.filter((slide) => Number(slide.dataset.project) === i)
				.sort((a, b) => Math.abs(swiper.slides.indexOf(a) - swiper.activeIndex) - Math.abs(swiper.slides.indexOf(b) - swiper.activeIndex))[0];
			if (nearest) swiper.slideToLoop(Number(nearest.dataset.swiperSlideIndex));
		});
	});

	// Een klik op een andere slide haalt die naar voren; de pijl op de actieve foto gaat naar de volgende.
	slider.addEventListener("click", (event) => {
		if (!swiper) return;

		const slide = event.target.closest(".swiper-slide");
		if (!slide) return;

		if (slide.classList.contains("swiper-slide-active")) {
			if (event.target.closest(".project-media-arrow")) swiper.slideNext();
			return;
		}

		swiper.slideToLoop(Number(slide.dataset.swiperSlideIndex));
	});

	const update = () => (desktop.matches ? !swiper && mount() : swiper && unmount());
	desktop.addEventListener("change", update);
	update();
});
